import { SVG_SIZE_M } from 'src/constants';
import {
  useBreakpoint,
  useCompareMode,
  useActiveModel,
  useQueryParams,
  useRightSidePanelActions,
  useComparingConversationsParams,
  useGetUser,
  useResetCompareSkills,
  useConversationParams,
  useChatHistory,
} from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { GuestAuthLinks } from 'src/pages/AuthPages/components/GuestAuthLinks';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { useContext } from 'react';
import { SquareSplitHorizontal } from '@phosphor-icons/react';
import AuthContext from 'src/contexts/AuthContext';

export const CompareModeButton = () => {
  const {
    setCompareMode,
    changeFirstCompareModel,
    resetCompareMode,
    firstCompareModel,
  } = useCompareMode();
  const { isDesktopAndUp } = useBreakpoint();
  const { isCompareMode } = useComparingConversationsParams();
  const { activeModel } = useActiveModel();
  const { removeSearchParam } = useQueryParams();
  const { toggleRightSidePanelExpanded, toggleRightSidePanelFullWidth } =
    useRightSidePanelActions();
  const { isOpenTier, isFreeTier, isStandardTier, isStandardTrialTier } =
    useGetUser();
  const { isGuestAccess } = useContext(AuthContext);
  const { onClearAttachments } = useContext(ThreadInputBoxContext);
  const { onResetCompareSkills } = useResetCompareSkills();
  const { isNinjaRetired } = useChatHistory();

  const { isLandingPage } = useConversationParams();

  const handleClick = () => {
    if (isCompareMode) {
      resetCompareMode();
      return;
    }

    onResetCompareSkills();

    removeSearchParam('editor');
    toggleRightSidePanelFullWidth(false);
    toggleRightSidePanelExpanded(false);
    onClearAttachments();

    setCompareMode();

    if (!firstCompareModel && activeModel) {
      changeFirstCompareModel(activeModel);
    }
  };

  const isDisabled =
    isOpenTier || isFreeTier || isStandardTier || isStandardTrialTier;
  console.log('[CompareModeButton] isGuestAccess:', isGuestAccess);

  if (
    !isDesktopAndUp ||
    isCompareMode ||
    !isLandingPage ||
    (isNinjaRetired && !isOpenTier)
  ) {
    console.log(
      '[CompareModeButton] return null:',
      isCompareMode,
      isLandingPage,
      isOpenTier,
      isDesktopAndUp,
      isNinjaRetired,
    );
    return null;
  }

  if (isGuestAccess) {
    return <GuestAuthLinks dataGTM="Chat-thread-attach-file-signup" />;
  }

  return (
    <Button
      color="secondary-outline"
      onClick={handleClick}
      disabled={isDisabled}
      tooltipContent={isDisabled ? 'Upgrade to unlock' : 'Compare Mode'}
    >
      <SquareSplitHorizontal size={SVG_SIZE_M} />
      Compare mode
    </Button>
  );
};
